'use es6';

import { Map as ImmutableMap, Record } from 'immutable';
import { RequestStatus } from '../constants/base';
const DEFAULTS = {
  crmDynamicPageObjects: ImmutableMap(),
  crmDynamicPageObjectsStatus: RequestStatus.UNINITIALIZED,
  crmPageObjectId: null
};

class CrmObjects extends Record(DEFAULTS) {}

export default CrmObjects;